module.exports = __webpack_public_path__ + "img/gm-icon.8771c343.svg";